var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "buildingsGuidelines" }, [
      _c("div", { staticClass: "mb-3" }, [
        _vm._v(
          "Follow these guidelines when editing to ensure formatting is correct:"
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("ul", [
          _c("li", [
            _vm._v('The "Building Key" is the '),
            _c("strong", [_vm._v("unique ID")]),
            _vm._v(" per building."),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v('A new "Building Key" value will '),
            _c("strong", [_vm._v("create")]),
            _vm._v(" a new building."),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v('An existing "Building Key" value will '),
            _c("strong", [_vm._v("update")]),
            _vm._v(" that existing building."),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              'In the "Floors" value field, be sure to separate floor names in the cell with a '
            ),
            _c("strong", [
              _vm._v(
                'comma listing them from lowest to highest (i.e. "Parking, Lobby, 2, 3, 4, 5")'
              ),
            ]),
            _vm._v("."),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              'Because the "Building Key" is used in the spaces file to associate all building attributes to mapped spaces, be sure to '
            ),
            _c("strong", [
              _vm._v(
                "input Building Key values that are easy to remember and make sense"
              ),
            ]),
            _vm._v(" when associating spaces."),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }